import styled from 'styled-components'

const Container = styled.div`
  border: solid transparent 1px;
  margin-bottom: 10px;
  position: relative;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.size.spacing.md};
`

const Header = styled.p`
  && {
    font-weight: ${props => props.theme.font.weight.bold};
    margin: 0;
  }
  display: inline-flex;
  justify-content: space-between;
`

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export { Container, HeaderContainer, Header, Box }
